<template>
    <div
        class="el-cal-item"
        :style="{
            borderColor: colorLuminance('#f9a825', -0.2),
            backgroundColor: '#bcaaa4',
        }"
    >
        <div class="el-cal-item__title">
            <div
                class="el-cal-item__title-text"
                v-if="booking.start && booking.end"
            >
                {{ booking.start.format('HH:mm') }} -
                {{ booking.end.format('HH:mm') }}
            </div>
            <div class="el-cal-item__title-text" v-if="booking.actor">
                <p>
                    {{ trans('form.label.bookingRef') }} :
                    {{ booking.actor.BookingReference }}
                </p>
            </div>
        </div>
        <div
            class="el-cal-item__resources-icon-list"
            v-if="booking.requestedResources"
        >
            <ul class="resources-icon-list inline-block">
                <li
                    v-if="booking.requestedResources.includes('FORKLIFT')"
                    class="resource-icon resource-icon__transporter"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('TRUCK')"
                    class="resource-icon resource-icon__truck"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('MANPOWER')"
                    class="resource-icon resource-icon__team"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('CRANE')"
                    class="resource-icon resource-icon__crane"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('TOOLS')"
                    class="resource-icon resource-icon__tools"
                ></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RoutePlanerSlotEvent',

    props: {
        booking: {
            type: Object,
            default: () => {},
        },

        element: {
            type: Object,
            default: () => {},
        },
        trans: {
            default: () => this.$t,
        },
    },

    methods: {
        colorLuminance(hex, lum) {
            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '')
            if (hex.length < 6) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
            }
            lum = lum || 0

            // convert to decimal and change luminosity
            var rgb = '#',
                c,
                i
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i * 2, 2), 16)
                c = Math.round(
                    Math.min(Math.max(0, c + c * lum), 255)
                ).toString(16)
                rgb += ('00' + c).substr(c.length)
            }

            return rgb
        },
    },
}
</script>
